export default __webpack_public_path__ + "static/media/ico_sort.7ce8aeff.svg";